import { calcItemPrice } from "@/common/util/calcItemPrice";
import { CloseOutlineIcon } from "@/components/icon/CloseOutlineIcon";
import { Body14Regular } from "@/components/typography/Body14Regular";
import { ItemDetailDto } from "@/types/dto/item-detail-dto";
import { Table } from "flowbite-react";
import { formatCommasNumber } from "../../../common/util/format-number-with-commas";
import { CustomCell } from "../CustomCell";

interface Props {
  item: ItemDetailDto;
  newDiscountRate: number;
  handleDeleteFromSelectedItems: (id: number) => void;
}

export const ItemSelectedDiscountsTableRow: React.FC<Props> = ({
  item,
  newDiscountRate,
  handleDeleteFromSelectedItems,
}) => {
  return (
    <Table.Row
      key={item.id}
      className="bg-white dark:border-gray-700 dark:bg-gray-800"
    >
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {item.name}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body max-w-[128px] overflow-hidden text-ellipsis whitespace-nowrap">
            {item.modelName}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {item.category.name}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {formatCommasNumber(item.price)}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {item.discountRate}%
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-disabled">
            {newDiscountRate}%
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {formatCommasNumber(calcItemPrice(item.price, newDiscountRate))}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <CloseOutlineIcon
            onClick={() => handleDeleteFromSelectedItems(item.id)}
          />
        </CustomCell>
      </Table.Cell>
    </Table.Row>
  );
};
